import { trackEvent } from '../utils/analytics';

/**
 * 전역 에러 핸들러 설정
 */
export const setupErrorTracking = () => {
  // 1. 처리되지 않은 Promise rejection 추적
  window.addEventListener('unhandledrejection', (event) => {
    trackEvent.error('Unhandled Promise Rejection', event.reason?.message || event.reason || 'Unknown error');
    console.error('Unhandled promise rejection:', event.reason);
  });

  // 2. 일반 JavaScript 에러 추적
  window.addEventListener('error', (event) => {
    trackEvent.error('JavaScript Error', `${event.message} at ${event.filename}:${event.lineno}:${event.colno}`);
    console.error('Global error:', event.error);
  });

  // 3. React Error Boundary를 위한 커스텀 에러 리포터
  window.reportError = (error, errorInfo) => {
    trackEvent.error('React Component Error', `${error.toString()} ${errorInfo?.componentStack || ''}`);
  };
};

/**
 * API 에러 추적 헬퍼
 */
export const trackAPIError = (endpoint, error, context = {}) => {
  const errorMessage = error.response?.data?.message || error.message || 'Unknown API error';
  const statusCode = error.response?.status || 'N/A';
  
  trackEvent.error('API Error', `${endpoint} - ${statusCode}: ${errorMessage}`);
  
  // 콘솔에도 상세 정보 출력
  console.error('API Error:', {
    endpoint,
    statusCode,
    errorMessage,
    context,
    fullError: error
  });
};

/**
 * Supabase 에러 추적 헬퍼
 */
export const trackSupabaseError = (operation, error, table = null) => {
  const errorMessage = error.message || 'Unknown Supabase error';
  const errorCode = error.code || 'N/A';
  
  trackEvent.error('Supabase Error', `${operation}${table ? ` on ${table}` : ''} - ${errorCode}: ${errorMessage}`);
  
  console.error('Supabase Error:', {
    operation,
    table,
    errorCode,
    errorMessage,
    fullError: error
  });
};

/**
 * 기능별 에러 추적
 */
export const trackFeatureError = (feature, action, error) => {
  const errorMessage = error.message || 'Unknown error';
  
  trackEvent.error(`${feature} Error`, `${action} - ${errorMessage}`);
  
  console.error(`${feature} Error:`, {
    action,
    errorMessage,
    fullError: error
  });
};
